module.exports = __webpack_public_path__ + "static/why-i-chose-cal-state-fullerton-index-23c62cc253870feddc99172d1fb61805.jpg";